import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IGetInput,
    IGetResponse,
    IBuyerChatRoomListClient,
} from 'interfaceAdapter/gatewaySchemas/IBuyerChatRoomListClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class BuyerChatRoomListClient implements IBuyerChatRoomListClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token, companyName } = input;

        const params = new URLSearchParams();
        const queryString = params.toString();
        if (companyName) {
            params.append('company_name', companyName);
        }
        const PATH = `${API_LOCATION_URL}/buyer/chat_rooms?${queryString}`;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-B': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = await fetch(PATH, {
                method,
                headers,
            });

            const { data, message } = await response.json();

            return {
                data,
                message,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
